export default {
    title: "您的审批经理是 {email}"
}